import classNames from 'classnames'

import s from './ListItem.module.scss'

type ListItemProps = {
  children: React.ReactNode
  decimal?: boolean
}

export const ListItem = ({ children, decimal }: ListItemProps) => {
  const styles = classNames(s.ELockListItem, {
    [s.decimal]: decimal,
  })

  return (
    <li className={styles}>
      <div className={s.listStyle} />
      {children}
    </li>
  )
}
